export const DIAGRAM_MEDIA_REFERENCES_CHANGED_EVENT = 'diagram-media-references-changed' as const;

export type DiagramMediaReferencesChangedPayload = {
  diagramId: string;
  addedKeys?: string[];
  removedKeys?: string[];
};
